export enum AppointmentType {
  APPOINTMENT_AUTHORIZED = 'APPOINTMENT_AUTHORIZED',
  APPOINTMENT_RESPONSIBLE = 'APPOINTMENT_RESPONSIBLE',
  APPOINTMENT_SYSTEM_ADMIN = 'APPOINTMENT_SYSTEM_ADMIN',
}
